import { AbstractTagSequence } from 'iframe/ts/player/controller/sequence/abstract/AbstractTagSequence';
import { IFramePlayerEvent } from 'iframe/ts/player/events/IFramePlayerEvent';
import { EmbedContext } from 'tag/ts/tag/model/enums/EmbedContext';
export class TagSequenceScripted extends AbstractTagSequence {
    #tag;
    constructor(iframePlayer) {
        super(iframePlayer, 'TagSequenceScripted');
        this.appEventsHandler(this.#onAppEvent, [
            IFramePlayerEvent.ON_COMPANION_PARAMS_RECEIVED,
            IFramePlayerEvent.ON_SMART_TAG_READY_CALLBACK,
            IFramePlayerEvent.ON_TAG_CREATE_REQUEST,
            IFramePlayerEvent.ON_TAG_CREATE_SUCCESS,
            IFramePlayerEvent.ON_UTAG_IMPORT_SUCCESS,
            IFramePlayerEvent.ON_VIDEO_LOAD_REQUEST
        ]);
    }
    get tag() {
        return this.#tag;
    }
    #processSmartTagOnReadyCallback = () => {
        this?.logger?.log('processSmartTagOnReadyCallback:', 'Scripted iframe!');
    };
    #onCompanionParamsReceived = (event) => {
        window.utag_data = event?.data?.utagData;
        this.utils.Delay.delay().then(() => {
            this.dispatchIFramePlayerEvent({
                type: IFramePlayerEvent.ON_UTAG_IMPORT_REQUEST,
                target: this,
                targetName: this.name
            });
        });
    };
    #onUtagImportSuccess = () => {
        this.dispatchIFramePlayerEvent({
            type: IFramePlayerEvent.ON_TAG_CREATE_REQUEST,
            target: this,
            targetName: this.name
        });
    };
    #onTagCreateRequest = () => {
        this.createTag(EmbedContext.IFRAME_SCRIPTED).then((data) => {
            this?.logger?.log('onTagCreateRequest:', 'Tag created:', data);
        });
    };
    #onAppEvent = (event) => {
        this?.logger?.log('onAppEvent:', event?.type, event);
        switch (event?.type) {
            case IFramePlayerEvent.ON_SMART_TAG_READY_CALLBACK:
                this.#processSmartTagOnReadyCallback();
                break;
            case IFramePlayerEvent.ON_COMPANION_PARAMS_RECEIVED:
                this.#onCompanionParamsReceived(event);
                break;
            case IFramePlayerEvent.ON_UTAG_IMPORT_SUCCESS:
                this.#onUtagImportSuccess();
                break;
            case IFramePlayerEvent.ON_TAG_CREATE_REQUEST:
                this.#onTagCreateRequest();
                break;
        }
    };
}
